'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const GroupBasedDataService=require('../../../dist-es6/client/services/groupBasedDataService');
const pulsarDate=require('pulsar-utils/dist-es6/pulsarDate');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const timespan=require('pulsar-utils/dist-es6/time/timespan');
const treeUtils=require('pulsar-utils/dist-es6/treeUtils');let

LiveGroupBasedDataService=function(_GroupBasedDataServic){_inherits(LiveGroupBasedDataService,_GroupBasedDataServic);_createClass(LiveGroupBasedDataService,null,[{key:'$inject',get:function()
{
return[
'$timeout',
'dateService',
'statisticalDisplayDataService',
'groupTreeService'];

}}]);

function LiveGroupBasedDataService($timeout,dateService,statisticalDisplayDataService,groupTreeService){_classCallCheck(this,LiveGroupBasedDataService);var _this=_possibleConstructorReturn(this,
_GroupBasedDataServic.call(this,$timeout,groupTreeService));
_this._dateService=dateService;
_this._statisticalDisplayDataService=statisticalDisplayDataService;

_this._lastFetchTime=void 0;return _this;
}LiveGroupBasedDataService.prototype.









_clearCache=function _clearCache(){
_GroupBasedDataServic.prototype._clearCache.call(this);
this._lastFetchTime=void 0;
};LiveGroupBasedDataService.prototype.

_fetchLatestData=function(){var ref=_asyncToGenerator(function*(){
throw new Error('Abstract! Implement _fetchLatestData on subclass.');
});function _fetchLatestData(){return ref.apply(this,arguments)}return _fetchLatestData}();LiveGroupBasedDataService.prototype.

_update=function(){var ref=_asyncToGenerator(function*(cancellationToken){for(var _len=arguments.length,args=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){args[_key-1]=arguments[_key]}
let latestData=yield this._fetchLatestData.apply(this,args);

if(cancellationToken.cancelled){
return;
}

this.groupTree=latestData.groupTree;
this._lastFetchTime=this._dateService.now();
this._estimatesAsOfTime=latestData.estimatesAsOfTime;
});function _update(cancellationToken){for(var _len2=arguments.length,args=Array(_len2>1?_len2-1:0),_key2=1;_key2<_len2;_key2++){args[_key2-1]=arguments[_key2]}return ref.apply(this,arguments)}return _update}();_createClass(LiveGroupBasedDataService,[{key:'lastFetchTime',get:function(){return this._lastFetchTime}},{key:'estimatesAsOfTime',get:function(){return this._estimatesAsOfTime}}]);return LiveGroupBasedDataService}(GroupBasedDataService);


module.exports=LiveGroupBasedDataService;
//# sourceMappingURL=liveGroupBasedDataService.js.map
